import { SITE_SOCIAL_ICONS, type SiteSocialNetwork } from './socialNetworks';

/** Stored in `content.ctaIcon` — distinct from Lucide PascalCase keys. */
export const CTA_SOCIAL_ICON_PREFIX = 'social:' as const;

export interface CtaSocialCatalogEntry {
  /** e.g. `social:whatsapp` */
  key: string;
  network: SiteSocialNetwork;
  label: string;
}

const CTA_SOCIAL_LABELS: Record<SiteSocialNetwork, string> = {
  whatsapp: 'WhatsApp',
  facebook: 'Facebook',
  instagram: 'Instagram',
  telegram: 'Telegram',
  tiktok: 'TikTok',
  x: 'X',
  youtube: 'YouTube',
};

/** Picker order — messengers first, then other brand marks. */
const CTA_SOCIAL_ORDER: readonly SiteSocialNetwork[] = [
  'whatsapp',
  'facebook',
  'instagram',
  'telegram',
  'tiktok',
  'x',
  'youtube',
] as const;

/**
 * Brand marks for messenger CTAs (Simple Icons). Lucide has no proper social
 * glyphs — picker + runtime use these. Mirrors `SITE_SOCIAL_ICONS`.
 */
export const CTA_SOCIAL_CATALOG: readonly CtaSocialCatalogEntry[] = CTA_SOCIAL_ORDER.map(
  (network) => ({
    key: `${CTA_SOCIAL_ICON_PREFIX}${network}`,
    network,
    label: CTA_SOCIAL_LABELS[network],
  }),
);

const CTA_SOCIAL_KEY_SET = new Set(CTA_SOCIAL_CATALOG.map((entry) => entry.key));

export function isCtaSocialIconKey(iconKey: string | null | undefined): boolean {
  return Boolean(iconKey && CTA_SOCIAL_KEY_SET.has(iconKey));
}

export function parseCtaSocialIconKey(
  iconKey: string | null | undefined,
): SiteSocialNetwork | null {
  if (!iconKey || !iconKey.startsWith(CTA_SOCIAL_ICON_PREFIX)) {
    return null;
  }
  const network = iconKey.slice(CTA_SOCIAL_ICON_PREFIX.length) as SiteSocialNetwork;
  return network in SITE_SOCIAL_ICONS ? network : null;
}

export function ctaSocialIconKeyForNetwork(network: SiteSocialNetwork): string {
  return `${CTA_SOCIAL_ICON_PREFIX}${network}`;
}
